import processCopyStaticRuneAdjs from './processCopyStaticRuneAdjs'
import processRemoveRuneAdjs from './processRemoveRuneAdjs'
import processRuneIntegrity from './processRuneIntegrity'

import store from '../store'

import getSpecificRuneIntegratedCount from '../helpers/getSpecificRuneIntegratedCount'
import getSpecificRuneCastingSkill from '../helpers/getSpecificRuneCastingSkill'
import trackRuneChanges from '../helpers/trackRuneChanges'
import calcIntegsTotal from '../helpers/calcIntegsTotal'
import loadTraits from '@/helpers/loadTraits'
//======================================================================================================
// process specific rune change
//------------------------------
// NB: Integrated status now controls Runecasting availability and rune adjs.
//============================================================================
export default function processSpecificRuneChange({
  change = null, // not required for new character rune
  rune,
  original_runes,
  changed_runes,
  character,
} = {}) {
  console.log('------------------------')
  console.log('IN processSpecificRuneChange')
  console.log('rune = ' + rune.name)
  console.log('######################################################')
  console.log('######################################################')
  console.log('rune = ', rune)
  console.log('######################################################')
  console.log('######################################################')
  //----------
  // declares
  //----------
  let existing_casting_skill = null
  let new_casting_skill_rune = null
  let apply_rune_adjs_rune = null
  let update_rune_item_adjs = {}
  //============================================================================
  //
  //                            INTERNAL FUNCTIONS
  //
  //============================================================================
  // FUNCTION: _removeRuneAdjs
  //---------------------------
  function _removeRuneAdjs({ rune, character }) {
    console.log('IN _removeRuneAdjs for rune = ' + rune.name)
    //----------------------------------------------------
    // remove rune adjs (delete rune specific skill adjs)
    //----------------------------------------------------
    character = processRemoveRuneAdjs({
      rune_name: rune.name,
      character,
    })
    console.log('back from _removeRuneAdjs - character = ', window.$deepCopy(character))
    return character
  }
  //============================================================================
  // FUNCTION: _loadRuneAdjs
  //-------------------------
  function _loadRuneAdjs({ rune, character }) {
    console.log('IN _loadRuneAdjs for rune = ' + rune.name)
    //-------------------------
    // get static rune for adjs
    //--------------------------
    const static_rune = store.getters['characters/getStaticRune'](rune.rune)
    console.log('static_rune = ', static_rune)
    //-----------------------------------------
    // copy static rune adjs to character rune
    //-----------------------------------------
    const copy_res = processCopyStaticRuneAdjs({ static_rune, target_rune: rune, character })
    //---------------
    // load response
    //---------------
    if (copy_res && copy_res.target_rune) {
      rune = copy_res.target_rune
      character = copy_res.character
    } else {
      console.error('Error copying static rune adjs for rune = ' + rune.name)
    }
    return { character, rune }
  }
  //============================================================================
  //
  //                                 MAIN FLOW
  //
  //============================================================================
  console.log('XXXXXX change = ', change)
  console.log('WWWWWW changed_runes = ', changed_runes)
  console.log('change.key = ' + change?.key)
  console.log('change.value = ' + change?.value)
  // console.log('character skills = ', character.skills)
  //============================================================================
  // NB: when here -  rune change has already been applied to character.runes
  //============================================================================
  // A. track rune changes (performed in RuneCard)
  //-----------------------------------------------
  changed_runes = trackRuneChanges({
    change,
    rune,
    original_runes,
    changed_runes,
    character_id: character.id,
  })
  console.log('[RUNE_EDIT_TRACE] processSpecificRuneChange tracked rune changes', {
    rune_id: rune?.id ?? null,
    rune_name: rune?.display_name ?? rune?.name ?? null,
    change_key: change?.key ?? null,
    change_value: change?.value ?? null,
    rune_state: {
      integrated: rune?.integrated ?? null,
      already_integrated: rune?.already_integrated ?? null,
      character_item: rune?.character_item ?? null,
    },
    changed_runes: window.$deepCopy(changed_runes || []),
  })
  //============================================================================
  // B. get casting skill for rune
  //-------------------------------
  console.log('B1. off to get casting skill for rune = ' + rune.name)
  existing_casting_skill = getSpecificRuneCastingSkill({
    skills: character.skills,
    target_rune: rune,
  })
  console.log('B2. returned existing_casting_skill = ', existing_casting_skill)
  //============================================================================
  // C. get integrated rune cnt with name same
  //-------------------------------------------
  //  NB: if 1 returned - this is the latest integrated position for this rune name
  //-------------------------------------------
  const integrated_rune_cnt = getSpecificRuneIntegratedCount({
    runes: character.runes,
    target_rune: rune,
  })
  console.log(
    'C1. integrated_rune_cnt = ',
    integrated_rune_cnt,
    ' for rune = ' + rune.name,
    ' NB: 1 means SINGLE integrated rune (latest)',
  )
  console.log('C2. RUNE CHANGE VALUE = ' + change.value)
  //============================================================================
  // D. INTEGRATED changed
  //-----------------------
  if (change.key == 'integrated') {
    //====================================================
    // D1. INTEGRATED disabled - keep runecasting skill, remove rune adjs only
    //----------------------------------------------------
    if (change.value == false) {
      console.log(`D1.1 ${rune.name} integrated=false`)
      //------------------------------------
      // proceed if integrated rune cnt = 0
      //  NB: if 0 returned - then the last integrated rune of this name was removed,
      //  so the skill remains but should become inactive/readonly with no rune adjs.
      //------------------------------------
      if (integrated_rune_cnt == 0) {
        console.log('D1.2. no integrated rune for this rune-name - proceed...')
        character = _removeRuneAdjs({ rune, character })
      } else {
        console.log(
          'D1.3. same rune still integrated - no need to remove rune adjs for = ' + rune.name,
        )
        console.log('D1.4. same rune integrated count = ' + integrated_rune_cnt)
      }
      console.log('[RUNE_EDIT_TRACE] processSpecificRuneChange integrated false result', {
        rune_id: rune?.id ?? null,
        rune_name: rune?.display_name ?? rune?.name ?? null,
        integrated_rune_count: integrated_rune_cnt,
        rune_state: {
          integrated: rune?.integrated ?? null,
          already_integrated: rune?.already_integrated ?? null,
        },
        changed_runes: window.$deepCopy(changed_runes || []),
      })
    } else {
      //===================================================
      // D2. INTEGRATED enabled - define runecasting skill
      //---------------------------------------------------
      console.log(`D2.1 ${rune.name} integrated=true`)
      //---------------------------------------
      // proceed if integrated rune cnt = 1
      //  NB: if 1 returned - then newly integrated for given rune name - so need to create runecasting skill
      //---------------------------------------
      if (integrated_rune_cnt == 1) {
        console.log('D2.2 newly ONE integrated rune for this rune-name - proceed...')
        //----------------
        // load rune adjs
        //----------------
        const load_res = _loadRuneAdjs({ rune, character })
        //---------------
        // load response
        //---------------
        if (load_res) {
          rune = load_res.rune
          character = load_res.character
          //--------------------------------------
          // tag rune to create new casting skill
          //--------------------------------------
          new_casting_skill_rune = rune
        } else {
          console.error('D2.5 Error copying static rune adjs for rune = ' + rune.name)
        }
        //
      } else {
        console.log(
          'D2.6 same rune still integrated - no need to reapply rune adjs for = ' + rune.name,
        )
        console.log('D2.7 same rune integrated count = ' + integrated_rune_cnt)
      }
    }
    //============================================================================
    // E. legacy active changed
    //-------------------------
  } else if (change.key == 'active') {
    console.log(
      `E1. ${rune.name} legacy active=${change.value} ignored for rune adj/runecasting state; integrated now controls availability`,
    )
    //============================================================================
    // F. character_item changed
    //---------------------------
  } else if (change.key == 'character_item') {
    //==============================================
    // F1. character item removed (clear item name)
    //----------------------------------------------
    if (change.value == null) {
      console.log('RUNE ITEM CHANGE = ', rune)
      console.log(`F1. ${rune.name} character_item =  ${change.value}`)
      const prevCharacterItem = change.previousValue ?? null
      // const prev_rune = original_runes.find((r) => r.id === rune.id)
      console.log('F1b. prevCharacterItem = ', prevCharacterItem)
      // clear item name from rune (character_item null to indicate no link to item)
      rune.item_name = ''
      //
      //============================================
      // F2. character item added (set item name)
      //------------------------------------------
    } else {
      console.log(`F2. ${rune.name} character_item = ${change.value}`)
      const linkedItem = character.items.find((it) => it.id === change.value)
      if (linkedItem) {
        rune.item_name = linkedItem.name
      } else {
        console.error(
          `F2.1 linked item not found for id = ${change.value} to set rune item_name for rune = ${rune.name}`,
        )
      }
    }
    //-----------------------------------------------------------------------------------------------
    // flag update to any adjs linked to this item for an integrated rune (e.g. remove item from adjs)
    //-----------------------------------------------------------------------------------------------
    if (rune.integrated) {
      update_rune_item_adjs = {
        rune,
        item_id: change.previousValue ?? null,
        change_value: change.value,
      }
    }
  }

  if (change.key == 'integrated' || change.key == 'starter') {
    character.pow_integs_tot = calcIntegsTotal({ runes: character.runes })
  }

  //============================================================================
  // G. go manage rune integrity
  //-----------------------------
  console.log('G. off to processRuneIntegrity for rune = ' + rune.name)
  changed_runes = processRuneIntegrity({
    change,
    rune,
    original_runes,
    changed_runes,
    character_id: character.id,
  })
  //-----------------------------------
  // update traits where rune has trait after integrity updates integrated rune state
  //------------------------------------
  console.log('DX.0 character runes = ', window.$deepCopy(character.runes))
  console.log('DX.1 rune = ', rune.name, ' has trait = ', rune.trait)
  if (rune.trait) {
    console.log('DX.2 off to reloadTraits to change traits')
    character = loadTraits({ character })
  }
  //============================================================================
  // returns
  //---------
  return {
    existing_casting_skill,
    apply_rune_adjs_rune,
    update_rune_item_adjs,
    new_casting_skill_rune,
    changed_runes,
    character,
  }
}
